// import {initialState,initialMutations,initialActions} from "../common_store";
//
// let defaultState = {
//     url_name: 'revenue-report/over-all/report'
// };
//
// defaultState = {...initialState, ...defaultState};
// defaultState = JSON.parse(JSON.stringify(defaultState));
//
// const getters = {
//     reportLoading: state => state.loading,
// };
//
// const actions = {...initialActions};
//
// const mutations = {...initialMutations};
//
// export default {
//     namespaced: true,
//     state: defaultState,
//     getters,
//     actions,
//     mutations
// }
import { initialState, initialMutations, initialActions } from "../common_store";

let moduleSpecificState = {
    url_name: 'revenue-report/over-all/report',
    totals: [],           // NEW: For the summary cards
    grandTotalNpr: '0.00', // NEW: Computed grand total
    grandTotalCount: 0, // NEW: Computed grand total
};

// Merge with initialState but prioritize module-specific
const state = {
    ...initialState,
    ...moduleSpecificState
};

// Clone to avoid reference issues (good practice)
const defaultState = JSON.parse(JSON.stringify(state));

const getters = {
    reportLoading: state => state.loading,
    reportTotals: state => state.totals,               // NEW getter
    reportGrandTotalNpr: state => state.grandTotalNpr,   // NEW getter
    reportGrandTotalCount: state => state.grandTotalCount   // NEW getter
};

// Use spread to inherit actions/mutations, then override setData
const mutations = {
    ...initialMutations,

    // OVERRIDE setData to handle totals
    setData(state, items) {
        // First, run the original common setData logic
        initialMutations.setData(state, items);

        // NOW: Add our custom logic for totals
        if (items.totals && Array.isArray(items.totals)) {
            // state.totals = items.totals;
            state.totals = items.totals.map(item => ({
                ...item,
                total_npr: parseFloat(item.total_npr || 0).toFixed(2),
                total_usd: parseFloat(item.total_usd || 0).toFixed(2),
                // total_count remains integer, no change needed
            }));
            // Compute grand total in NPR
            const grandTotal = items.totals.reduce((sum, item) => {
                return sum + parseFloat(item.total_npr || 0);
            }, 0);
            const grandTotalCount = items.totals.reduce((sum, item) => {
                return sum + parseInt(item.total_count || 0, 10);
            }, 0);
            state.grandTotalCount = grandTotalCount;
            state.grandTotalNpr = grandTotal.toFixed(2);
        } else {
            state.totals = [];
            state.grandTotalNpr = '0.00';
            state.grandTotalCount = 0;
        }
    }
};

const actions = {
    ...initialActions
    // No need to override fetchData — it already commits 'setData'
};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    actions,
    mutations
};